import React from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import Text from '../Text/Text'
import Link from 'next/link'
import InfoIcon from '../../static/Info/InfoIcon'
import PromoOfferEndsInCounter from '../PromoOffer/promoOfferEndsInCounter'
import { SCREEN_SIZE } from '../../lib/Media'
import { getUserType } from '../../utils/userType'
import { ProductDetailMetaData } from '../ProductCardMetaData/ProductCardMetaData'

const PriceDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledA = styled.a`
  color: ${defaultTheme.ColorBaseBrandPrimary500};
  font-weight: bold;
  text-decoration: none;
`

const PriceAndDiscount = styled.div`
  display: flex;
`

const Heading = styled.span`
  margin-right: 0.8rem;
  color: #333333;
`

const SubHeading = styled.div`
  display: flex;
  text-decoration: line-through;
  justify-content: center;
  align-items: center;
  color: #696969;
`

const StyledText = styled(Text)`
  font-size: 1.625rem;
  color: ${defaultTheme.ColorBaseMineShaft700};
`

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledLinkPointInfo = styled.h3`
  margin-top: 0.125rem;
  a {
    display: inline-block;
    vertical-align: middle;
    padding-left: 0.25rem;
  }
`

const SimplePromotionContainer = styled.div`
  margin-bottom: 0.3rem;
  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 0.75rem;
  }
`

const Elipsis = styled.span`
  white-space: nowrap;
  max-width: ${props => (props.width ? props.width : '10rem')};
  overflow: hidden;
  text-overflow: ellipsis;
  &.quantity {
    max-width: 7.75rem;
    ${SCREEN_SIZE.From.Tablet} {
      max-width: 9.25rem;
    }
    ${SCREEN_SIZE.From.Hd} {
      max-width: 10rem;
    }
  }
`

const WrapperSection = styled.div`
  display: flex;
  font-size: 0.75rem;
  line-height: 1rem;
  span {
    margin-top: 0.25rem;
    color: #333;
    a {
      padding-left: 0.25rem;
    }
  }
`

const PromoExpiryWrapper = styled.span`
  color: #696969;
  font-weight: bold;
  display: inline-block;
  margin-left: 0.5rem;
`

const PriceDetails = props => {
  const data = props && props.data && props.data[0]
  const { name, metaData, handleTrackOnBrandClick, linkpoint = {} } = props
  let mrp = 0,
    discount = 0
  let brandInfo = {}
  let linkpointInfo = {}

  if (data) {
    mrp = data.mrp
    discount = data.discount
    brandInfo = data.brand
    if (getUserType() !== 'B2B') {
      linkpointInfo = linkpoint
    }
  }
  mrp = Number(mrp || 0)
  discount = Number(discount || 0)
  const currency = data && data.currency && data.currency.symbol
  const finalPrice = mrp - discount
  const sp = props.simplePromo
  return (
    <PriceDetailsContainer>
      <PriceAndDiscount>
        <Heading>
          {data.mrp !== undefined && data.mrp !== null && (
            <StyledText size="xxl" weight="black">{`${
              finalPrice > 0
                ? (currency || '') + (mrp - discount).toFixed(2)
                : 'Free'
            }`}</StyledText>
          )}
        </Heading>
        {discount ? (
          <SubHeading>
            <Text size="small">{`${currency || ''}${mrp.toFixed(2)}`}</Text>
          </SubHeading>
        ) : null}
      </PriceAndDiscount>
      {sp && (
        <SimplePromotionContainer>
          {discount ? (
            <Text size="small" weight="bold" color="#ea6100">
              Save {`${currency || ''}${discount.toFixed(2)}`}
            </Text>
          ) : (
            ''
          )}
          {sp.validTill && (
            <PromoExpiryWrapper>
              <PromoOfferEndsInCounter validTill={sp.validTill} />
            </PromoExpiryWrapper>
          )}
        </SimplePromotionContainer>
      )}
      <ProductInfo>
        <Heading>
          <Text
            size="large"
            weight="regular"
            color={defaultTheme.ColorBaseMineShaft700}
          >
            {name}
          </Text>
        </Heading>
        <WrapperSection>
          <ProductDetailMetaData metaData={metaData} brandInfo={brandInfo} />
          {brandInfo && brandInfo.name && (
            <Elipsis width="168px" data-testid="brandDetails">
              <span>Brand:</span>
              <Link
                href={encodeURI(
                  `/brandDetails?slug=${encodeURIComponent(brandInfo.slug)}`
                )}
                as={encodeURI(`/brand/${brandInfo.slug}`)}
                passHref
                legacyBehavior
              >
                <StyledA
                  onClick={() =>
                    handleTrackOnBrandClick(encodeURI(brandInfo.slug))
                  }
                >
                  {brandInfo.name}
                </StyledA>
              </Link>
            </Elipsis>
          )}
        </WrapperSection>
        {linkpointInfo?.faq_url && !linkpointInfo.eligible && (
          <StyledLinkPointInfo>
            <Text size="small" weight="regular" color="#333333">
              Not eligible for LinkPoints and promo codes
            </Text>
            <a
              href={linkpointInfo.faq_url}
              target="_blank"
              rel="noreferrer noopener"
            >
              <InfoIcon height="16px" width="16px" />
            </a>
          </StyledLinkPointInfo>
        )}
      </ProductInfo>
    </PriceDetailsContainer>
  )
}

export default PriceDetails
